 <template>
 <div>
  <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

   <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
        <v-card-text>Essa operação irá afectar o sistema como um todo, por isso pergunto novamente tens realmente a certeza de que desejas continuar com essa operação?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="save()">Concordar</v-btn>
          <v-btn color="green darken-1" text @click="dialog=false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-sheet class="pa-5">
          <v-toolbar-title>Emolumentos Activos   </v-toolbar-title>

    <v-list>
      <v-list-item
      disabled= "false"
        v-for="item in abertInsts"
        :key="item.pkpagamentoEmolumento"
      >
        <v-list-item-content>
  <v-col cols="12" sm="12" md="12">

           <v-switch  v-model="item.status_2" v-on:click="copy(item)" :label="item.instituicao" disabled></v-switch>
            <span>Total Pago: {{item.pagamento}} </span><br>
           <span>Quantidade inicial: {{item.quantidade_inicial}} </span><br>
            <span>Saldo transportado: {{item.saldo_transportado}} </span><br>
           <span>Consumo: {{item.consumo}} </span><br>
           <span>Data de pagamento: {{item.data_2}} </span>
       </v-col>

        </v-list-item-content>

      </v-list-item>
    </v-list>

  </v-sheet>

 </div>

</template>

<script>
import axios from '../../plugins/axios'
var ls = require('local-storage')
export default {
  data: () => ({
    abertInsts: [],
    descricao: '',
    status_2: false,
    dialog: false,
    disabled: false,
    dados: null,
    isLoading: true,

    editedItem: {
      idAnoLectivo: 0,
      descricao: '',
      status_2: false

    }

  }),
  created () {
    this.initialize()
    // check if classe has been selected otherwise send back to painel to select
  },

  computed: {

  },

  methods: {

    resetar () {
      confirm('Tem certez que quer redefinir as configuracoes de Abertura e fecho ?') &&
        this.aberfechotInstituicaoReset()
    },
    /* Copiar os dados de item para dados */
    async copy (item) {
      this.disabled = false
      this.dialog = true
      this.dados = item
    },
    async   save () {
      this.dialog = false
      // this.editedItem=item
      const ls = require('local-storage')
      ls.set('anolectivo', this.dados.descricao)
      var params = {
        id: this.dados.idAnoLectivo,
        data: new Date(),
        autor: ls.get('nomeUsuario')
      }

      try {
        let msg = await axios
          .post('/mudarEpocaUpdate', params)
          .then(res => res.data)
          // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        this.initialize()
        setTimeout(() => {
          this.logout()
        }, 1000)
      }
    },
    logout () {
      ls.remove('token')
      ls.clear()
      this.$router.push('/')
    },

    async initialize () {
      try {
        this.abertInsts = await axios
          .get('/verificarPagamentoAll')
          .then(res => res.data)
        this.isLoading = false
        // this.abertInsts = this.abertInsts.filter(t => t.quantidade_inicial > t.consumo)
      } catch (error) {
        this.isLoading = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    //

    async aberfechotInstituicaoReset () {
      try {
        let msg = await axios
          .post('/aberfechotInstituicaoReset')
          .then(res => res.data)
          // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        this.initialize()
      } catch (error) {

      }
    }

  }

}

</script>
